//import {InputCompletedContext} from '../objects/Context/input_completed_context';
import React from 'react';
import "../components/game-views/GameViews/gameViews.css";
import "../components/game-views/GameViews/gameViewMedia.css";



class MoodRetirementDisplay extends React.Component {
    constructor(props) {
        super(props);
          
    this.state = {
        
    };
} 

   render(){
    

    return <>
        <div className="speedometer-wrapper">
            <div className="cursor-is-pointer speedometer"
                onClick={() => this.props.openMoodRetirementModal()}>
                <img
                    src={"./assets/speedometerMoodRetirement.png"}
                    alt="Retirement mood speedometer"
                    className="speedometer-image"
                />

                <div
                    className="arrow arrow-primary"
                    style={{ transform: `rotate(${this.props.moodRotation}deg)` }}
                />

                <div
                    className="arrow arrow-secondary"
                    style={{ transform: `rotate(${this.props.retirementRotation}deg)` }}
                />
            </div>
        </div>
    </>
}

}

export default MoodRetirementDisplay;